// extracted by mini-css-extract-plugin
export var background = "header-module--background--cfca0";
export var backgroundText = "header-module--background-text--2672c";
export var backgroundWithoutBanner = "header-module--background-without-banner--c5678";
export var burgerMenu = "header-module--burger-menu--b5f0b";
export var burgerMenuOpen = "header-module--burger-menu-open--fa89b";
export var burgerMenuTitle = "header-module--burger-menu-title--2ca1f";
export var fieldAndButton = "header-module--field-and-button--a6181";
export var header = "header-module--header--905b9";
export var headerSearch = "header-module--header-search--3410e";
export var inputSearch = "header-module--input-search--1c54f";
export var logoSite = "header-module--logo-site--0d6e9";
export var logoSiteImg = "header-module--logo-site-img--d4358";
export var mainNav = "header-module--main-nav--16ceb";
export var mainSearch = "header-module--main-search--cc58c";
export var navItem = "header-module--nav-item--5436f";
export var navItemName = "header-module--nav-item-name--c62e5";
export var navList = "header-module--nav-list--bf658";
export var notificationButton = "header-module--notification-button--48f27";
export var searchButton = "header-module--search-button--1c15b";
export var searchButtonActive = "header-module--search-button-active--3b94c";
export var subNav = "header-module--sub-nav--5731d";
export var subNavContainer = "header-module--sub-nav-container--a36b2";
export var subNavItemTitle = "header-module--sub-nav-item-title--2a656";
export var subNavName = "header-module--sub-nav-name--f9eaf";
export var submitSearch = "header-module--submit-search--ced07";